import { useStore, useStoreActions } from "../../store/store-context";
import { useOverlayContext } from 'seagull';
import React, { useEffect, useState } from 'react';
import { ConfirmationModal, Typography } from 'seagull';
import { handlePromise } from "../../infra/utils";
import { ContactModalType, ManageContactModal } from "./index";
import { OptionType } from "../QboCustomerDropdown/QboCustomerDropdown.utils";
import QboCustomerDropdown from "../QboCustomerDropdown/QboCustomerDropdown";
import { useOnMount } from "../../hooks/useOnMount";
import { useContactActions } from "../../hooks/useContactActions";
import { selectors } from "../../store/state-selectors";
import { ErrorText } from "../../constants";
import { ErrorResponse, ServerError } from "../../infra/ErrorResponse";
import { NewContactModel } from "../../models/ContactModel";
export function ManageContactModalForVendor(props) {
  var _ref, _existingContact$firs, _ref2, _existingContact$last, _ref3, _existingContact$comp, _ref4, _existingContact$emai, _ref5, _existingContact$phon;
  const {
    existingContact,
    newContactToCreate,
    origin
  } = props;
  const {
    api,
    fetchQboCustomers,
    fetchIntegrations
  } = useStoreActions();
  const {
    loading,
    data: qboCustomers
  } = useStore(state => state.qboCustomers);
  const overlayContext = useOverlayContext();
  const {
    fetchContactProposals,
    withdrawToEditContactProposals
  } = useContactActions();
  const [qboCustomerOption, setQboCustomerOption] = useState(null);
  const [contactProposals, setContactProposals] = useState([]);
  const isLinkedToQbo = useStore(selectors.integration.isLinkedToQbo);
  const contact = {
    firstName: (_ref = (_existingContact$firs = existingContact === null || existingContact === void 0 ? void 0 : existingContact.firstName()) !== null && _existingContact$firs !== void 0 ? _existingContact$firs : newContactToCreate === null || newContactToCreate === void 0 ? void 0 : newContactToCreate.firstName) !== null && _ref !== void 0 ? _ref : '',
    lastName: (_ref2 = (_existingContact$last = existingContact === null || existingContact === void 0 ? void 0 : existingContact.lastName()) !== null && _existingContact$last !== void 0 ? _existingContact$last : newContactToCreate === null || newContactToCreate === void 0 ? void 0 : newContactToCreate.lastName) !== null && _ref2 !== void 0 ? _ref2 : '',
    companyName: (_ref3 = (_existingContact$comp = existingContact === null || existingContact === void 0 ? void 0 : existingContact.companyName()) !== null && _existingContact$comp !== void 0 ? _existingContact$comp : newContactToCreate === null || newContactToCreate === void 0 ? void 0 : newContactToCreate.companyName) !== null && _ref3 !== void 0 ? _ref3 : '',
    email: (_ref4 = (_existingContact$emai = existingContact === null || existingContact === void 0 ? void 0 : existingContact.email()) !== null && _existingContact$emai !== void 0 ? _existingContact$emai : newContactToCreate === null || newContactToCreate === void 0 ? void 0 : newContactToCreate.email) !== null && _ref4 !== void 0 ? _ref4 : '',
    phone: (_ref5 = (_existingContact$phon = existingContact === null || existingContact === void 0 ? void 0 : existingContact.phone()) !== null && _existingContact$phon !== void 0 ? _existingContact$phon : newContactToCreate === null || newContactToCreate === void 0 ? void 0 : newContactToCreate.phone) !== null && _ref5 !== void 0 ? _ref5 : ''
  };
  const hasContact = existingContact && existingContact.id();
  const modalType = hasContact ? ContactModalType.Edit : ContactModalType.Create;
  const isEmailReadonly = Boolean(existingContact && !existingContact.isEmailEditable());
  useOnMount(() => {
    if (isLinkedToQbo) {
      Promise.all([fetchQboCustomers(), fetchIntegrations()]);
    }
    if (existingContact && !isEmailReadonly) {
      fetchContactProposals(existingContact.id()).then(setContactProposals);
    }
  });
  useEffect(() => {
    if (existingContact !== null && existingContact !== void 0 && existingContact.integratedId()) {
      const mappedQboCustomer = qboCustomers === null || qboCustomers === void 0 ? void 0 : qboCustomers.find(qboCustomer => qboCustomer.id() === existingContact.integratedId());
      if (mappedQboCustomer) {
        setQboCustomerOption({
          type: OptionType.Existing,
          customer: mappedQboCustomer
        });
      }
    }
  }, [qboCustomers]);
  const onSaveContact = async contactToSave => {
    if (existingContact && contactToSave.email !== (existingContact === null || existingContact === void 0 ? void 0 : existingContact.email()) && contactProposals.length > 0) {
      const shouldWithdrawProposals = await openWithdrawToProposalModal();
      if (existingContact && shouldWithdrawProposals) {
        await withdrawToEditContactProposals(existingContact.id());
      } else {
        return;
      }
    }
    const savedContact = await saveContactRequest(contactToSave);
    if (!savedContact.success) {
      const message = new ErrorResponse(savedContact.error).saveContactErrorText();
      overlayContext.showErrorToast(message, 'save-contact-error-toast');
    } else {
      if (savedContact && isLinkedToQbo) {
        await handleQboMapping(savedContact.data);
      }
      return savedContact.data;
    }
  };
  const openWithdrawToProposalModal = () => {
    return overlayContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref6 => {
        let {
          dismissModal
        } = _ref6;
        return /*#__PURE__*/React.createElement(ConfirmationModal, {
          skin: "danger",
          title: "This client has proposals awaiting approval",
          content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, null, "Making changes to the client's email address will automatically withdraw pending proposals. Withdrawn proposals will be saved in your drafts.")),
          textAlignCenter: false,
          onPrimaryButtonClick: () => dismissModal(true),
          onSecondaryButtonClick: () => dismissModal(false),
          primaryButtonLabel: "Save changes and withdraw proposals",
          secondaryButtonLabel: "Back",
          primaryButtonTestid: "confirm-withdraw",
          secondaryButtonTestid: "cancel-withdraw",
          "data-testid": "confirm-withdraw-modal"
        });
      }
    });
  };
  const handleQboMapping = async savedContact => {
    try {
      const shouldCreateNew = (qboCustomerOption === null || qboCustomerOption === void 0 ? void 0 : qboCustomerOption.type) === OptionType.CreateNew;
      if (shouldCreateNew) {
        await api.contact.qboCreate(savedContact.id());
      } else {
        const isLinking = (qboCustomerOption === null || qboCustomerOption === void 0 ? void 0 : qboCustomerOption.type) === OptionType.Existing;
        const newIntegratedId = isLinking ? qboCustomerOption.customer.id() : undefined;
        const isDirty = (existingContact === null || existingContact === void 0 ? void 0 : existingContact.integratedId()) !== newIntegratedId;
        if (isDirty) {
          await api.contact.qboLink(savedContact.id(), {
            version: savedContact.version(),
            integratedId: newIntegratedId
          });
        }
      }
    } catch (err) {
      const isDuplicateError = new ErrorResponse(err).hasServerError(ServerError.DuplicateNameExists);
      overlayContext.showErrorToast(isDuplicateError ? 'Could not create a new client in QuickBooks Online. A client with these details already exists.' : ErrorText.UnexpectedErrorTryAgain, isDuplicateError ? 'duplicate-contact-toast' : 'general-error-toast');
    }
  };
  const saveContactRequest = data => {
    if (hasContact) {
      const contactToUpdate = existingContact.update(data);
      return handlePromise(api.contact.update(contactToUpdate));
    } else {
      return handlePromise(api.contact.create(NewContactModel.make(data)));
    }
  };
  const onCancelClick = async () => {
    let shouldCloseModal = true;
    if (newContactToCreate) {
      shouldCloseModal = await overlayContext.showModal({
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: _ref7 => {
          let {
            dismissModal
          } = _ref7;
          return /*#__PURE__*/React.createElement(ConfirmationModal, {
            title: "Are you sure?",
            content: "All unsaved contact details will be lost",
            onPrimaryButtonClick: () => dismissModal(true),
            onSecondaryButtonClick: () => dismissModal(false),
            primaryButtonLabel: "Exit without saving",
            secondaryButtonLabel: "Cancel",
            primaryButtonTestid: "confirm",
            secondaryButtonTestid: "un-confirm",
            "data-testid": "confirm-losing-unsaved-data"
          });
        }
      });
    }
    return shouldCloseModal;
  };
  return /*#__PURE__*/React.createElement(ManageContactModal, {
    onClose: props.onClose,
    contact: contact,
    modalType: modalType,
    onSaveContact: onSaveContact,
    emailEditState: {
      isEmailReadonly,
      tooltipContent: isEmailReadonly ? 'Clients with whom you have an agreement cannot have their email addresses changed' : undefined
    },
    onCancelClick: onCancelClick,
    origin: origin,
    extraCellContent: isLinkedToQbo ? /*#__PURE__*/React.createElement(QboCustomerDropdown, {
      value: qboCustomerOption,
      onChange: val => setQboCustomerOption(val),
      qboCustomers: qboCustomers || [],
      textFieldProps: {
        label: 'QuickBooks Online mapping'
      },
      loading: loading,
      disabled: existingContact && existingContact.isSample()
    }) : null
  });
}